var gql = require("@apollo/client").gql;

const TARIFFS_HOUSE_FILTER_QUERY = gql`
    query FiltersTariffsAddress(
        $houseId: Int!
        $filter: String
        $region_url: String
        $exists: String
    ) {
        filtersTariffsAddress: tariffsByHouseV2(
            house_id: $houseId
            filter: $filter
            region_url: $region_url
            with_aggregate: 1
            exists: $exists
            optimize: true
        ) {
            aggregation {
                providers {
                    id
                    name
                    translit_name
                }
            }
        }
    }
`;

module.exports = TARIFFS_HOUSE_FILTER_QUERY;
